<template>
  <div class="mail-logs">
    <div class="listing">
      <b-table :data="lines" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column class="datetime" field="datetime" label="Time">
            {{props.row.datetime|shortDatetime}}
          </b-table-column>
          <b-table-column class="key" field="key" label="Key">
            {{props.row.key|toWords}}
          </b-table-column>
          <b-table-column field="subject" label="To">
            <a :href="props.row.to|mailto" :title="props.row.fromToMessage">{{props.row.to}}</a>
          </b-table-column>
          <b-table-column field="charcount" label="Transaction ID">
            {{props.row.transactionid}}
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { getMailLog } from "../api/methods";
import filters from "../mixins/filters";

export default {
  name: 'MailLog',
  mixins: [filters],
  data() {
    return {
      lines: [],
    }
  },
  computed: {
    numLines() {
    return this.lines.length;
    },
  },
  mounted() {
    setTimeout(() => {
      this.getMailLog();  
    }, 500)
  },
  methods: {
    getMailLog(reload) {
      if (this.lines.length < 1 || reload === true) {
        getMailLog('json', 100).then(data => {
          if (data.lines instanceof Array) {
            this.lines = data.lines.map(line => {
              line.fromToMessage = ['from:', line.from, 'to:', line.to].join(' ');
              return line;
            });
          }
        });
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
  }
}
</script>